// @flow
import { getSessionItem, setSessionItem } from './sessionStorage';

const REFRESH_LOCK_KEY = 'token_refresh_lock';
const REFRESH_LOCK_DURATION = 10e3; // 10 seconds

export const isLockedByMe = (lockKey: string): boolean => {
  const existingLock = getSessionItem(REFRESH_LOCK_KEY);
  if (!existingLock) return false;

  const [existingLockKey] = existingLock.split('_');
  return existingLockKey === lockKey;
};

export const isRefreshLocked = (): boolean => {
  const existingLock = getSessionItem(REFRESH_LOCK_KEY);
  if (!existingLock) return false;

  const lockTime = parseInt(existingLock.split('_')[1], 10);
  const now = Date.now();
  return now - lockTime < REFRESH_LOCK_DURATION;
};

export const acquireRefreshLock = async (): Promise<boolean> | boolean => {
  if (isRefreshLocked()) {
    return false;
  }
  const now = Date.now();
  const lockKey = Math.random()
    .toString(32)
    .substring(2);

  setSessionItem(REFRESH_LOCK_KEY, `${lockKey}_${now}`);

  const refreshWaitTime = Math.random() * 1000 + 500;
  await new Promise((r) => setTimeout(r, refreshWaitTime));
  return isLockedByMe(lockKey);
};
